import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import CreatePortfolioButton from '../../components/dashboard/portfolios/CreatePortfolioButton';
import { useTranslation } from 'react-i18next';
import ListOfFunds from '../../components/libraryOfFunds/ListOfFunds';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { loadFavorites, loadListOfFunds } from '../../store/actions/libraryOfFunds';
import ListOfFundsPagination from '../../components/libraryOfFunds/ListOfFundsPagination';
import ListOfFundsFilters from '../../components/libraryOfFunds/ListOfFundsFilters';
import LatestsFunds from '../../components/dashboard/funds/LatestsFunds';

const ListOfFundsPage: React.FC = () => {
    // const { id } = useParams();
    const { t } = useTranslation();
    const funds = useAppSelector(state => state.libraryOfFundsReducer.funds);
    const favorites = useAppSelector(state => state.libraryOfFundsReducer.favorites);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (funds === undefined) {
            dispatch(loadListOfFunds());
        }
    }, [funds, dispatch]);

    useEffect(() => {
        if (favorites === undefined) {
            dispatch(loadFavorites());
        }
    }, [favorites, dispatch]);

    return <Box display={"flex"} margin={"0"} justifyContent={"center"} overflow={"auto"}>
        <Box display={"flex"} margin={"50px 56px"} alignItems={"center"} flexDirection={"column"} width={"100%"} maxWidth={"1400px"} gap={"21px"}>
            <Box display={"flex"} justifyContent={"space-between"} width={"100%"}>
                <Typography variant='h3'>{t('LibraryOfFundsPageTitle')}</Typography>
                <Box><CreatePortfolioButton /></Box>
            </Box>
            {/* <LatestsFunds orientation='Horizontal' /> */}
            {funds !== undefined ?
                <>
                    <ListOfFundsFilters />
                    <ListOfFunds />
                    <ListOfFundsPagination />
                </>
                :
                <Box display={"flex"} width={"100%"} justifyContent={"center"}>
                    <CircularProgress />
                </Box>
            }
        </Box>
    </Box>;
}

export default ListOfFundsPage;